export enum TestEnvironmentKind {
  None = "None",
  UnitTesting = "Unit Testing"
}
